module.exports = __webpack_public_path__ + "static/media/17-RotHeatExchanger - Water cool - No heat.696e7d3f.png";